import { useState, type ReactNode } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, Card, CardContent, Collapse, IconButton, Stack, Typography } from '@mui/material';

type Props = { index: number; title: string; children: ReactNode };

export default function FormSection({ index, title, children }: Props) {
  const [expanded, setExpanded] = useState(true);
  const contentId = `form-section-${index}`;

  return (
    <Card>
      <CardContent>
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: '50%',
                bgcolor: 'primary.main',
                color: 'common.white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 700,
              }}
            >
              {index}
            </Box>
            <Typography variant="h6" fontWeight={700}>
              {title}
            </Typography>
          </Stack>
          <IconButton
            aria-label={`${expanded ? 'Recolher' : 'Expandir'} ${title}`}
            aria-expanded={expanded}
            aria-controls={contentId}
            onClick={() => setExpanded((current) => !current)}
          >
            {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </Stack>
        <Collapse in={expanded} timeout="auto" unmountOnExit={false}>
          <Stack id={contentId} spacing={2} sx={{ pt: 1 }}>
            {children}
          </Stack>
        </Collapse>
      </CardContent>
    </Card>
  );
}
